/**
 * @generated SignedSource<<a053299e5099927d765778cb43bb145c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutSetUpActions_buyer$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly profile: {
    readonly email: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTrackingActions_buyer" | "checkoutUIActionsTransactionSetup_buyer">;
  readonly " $fragmentType": "checkoutSetUpActions_buyer";
};
export type checkoutSetUpActions_buyer$key = {
  readonly " $data"?: checkoutSetUpActions_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutSetUpActions_buyer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutSetUpActions_buyer"
};

(node as any).hash = "d4d5b2c0be38a973b44c984596d772b7";

export default node;
